import { authorizedFetch, baseUrl, buildHeaders, getResponseOrThrow, urlFilters } from "./common";

export const apiTopicsProgressionByMonthRequest = (token, company_id, filters) => {
  return authorizedFetch(urlFilters(`${baseUrl}/company/${company_id}/metrics/topic/progression/month`, filters),
    {
      method: "GET",
      headers: buildHeaders(token)
    })
    .then(getResponseOrThrow)
    .catch((error) => Promise.reject(error));
};

export const apiTopicEvolution = (token, company_id, topic_id) => {
  return fetch(`${baseUrl}/company/${company_id}/metrics/topic/${topic_id}/progression`,
    {
      method: "GET",
      headers: buildHeaders(token)
    })
    .then(getResponseOrThrow)
    .catch((error) => Promise.reject(error));
};

export const apiTopicEvolutionFilteredRequest = (token, company_id, topic_id, filters) => {
  return fetch(urlFilters(`${baseUrl}/company/${company_id}/metrics/topic/${topic_id}/progression`, filters),
    {
      method: "GET",
      headers: buildHeaders(token)
    })
    .then(getResponseOrThrow)
    .catch((error) => Promise.reject(error));
};

export const apiPersonTopicSummaryRequest = (token, personId, page = 1) => {
  return fetch(`${baseUrl}/person/${personId}/topics/summary?page=${page}`, {
    headers: buildHeaders(token)
  }).then(getResponseOrThrow).catch(error => Promise.reject(error));
}
